import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/hospitality/HospitalityClient.tsx");
